import React, { useState } from 'react';
import { useUpdatePiece } from '../hooks/usePieces';

interface BulkUpdatePiecesModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedPieces: any[];
  onSuccess: () => void;
}

const BulkUpdatePiecesModal: React.FC<BulkUpdatePiecesModalProps> = ({
  isOpen,
  onClose,
  selectedPieces,
  onSuccess
}) => {
  const [formData, setFormData] = useState({
    numero: '',
    etage: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const updatePiece = useUpdatePiece();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const updatePromises = selectedPieces.map(piece => 
        updatePiece.mutateAsync({
          id: piece.id,
          data: {
            ...(formData.numero && { numero: formData.numero }),
            ...(formData.etage && { etage: parseInt(formData.etage) })
          }
        })
      );

      await Promise.all(updatePromises);
      onSuccess();
      onClose();
    } catch (error) {
      console.error('Erreur lors de la mise à jour en masse:', error);
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
        <h2 className="text-lg font-semibold mb-4">
          Modifier {selectedPieces.length} pièce{selectedPieces.length > 1 ? 's' : ''}
        </h2>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Numéro
            </label>
            <input
              type="text"
              value={formData.numero}
              onChange={(e) => setFormData({ ...formData, numero: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Ex: 101"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Étage
            </label>
            <input
              type="number"
              min="0"
              max="10"
              value={formData.etage}
              onChange={(e) => setFormData({ ...formData, etage: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Ex: 1"
            />
          </div>

          <div className="flex gap-3 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 px-4 py-2 text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 transition-colors"
            >
              Annuler
            </button>
            <button
              type="submit"
              disabled={isLoading}
              className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50 transition-colors"
            >
              {isLoading ? 'Modification...' : 'Modifier'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default BulkUpdatePiecesModal;
